var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', _vm._b({
    attrs: {
      "offset-x": "",
      "min-width": "200",
      "max-width": "240",
      "left": _vm.left,
      "right": _vm.right,
      "nudge-right": _vm.right ? 4 : 0,
      "nudge-left": _vm.left ? 4 : 0,
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_vm._t("default", null, null, {
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.open,
      callback: function ($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, 'v-menu', _vm.$attrs, false), [_c('div', {
    staticClass: "white d-flex flex-column",
    staticStyle: {
      "height": "calc(100vh - 24px)"
    }
  }, [_vm._t("header", null, null, {
    close: function () {
      return _vm.open = false;
    }
  }), _c('div', {
    staticClass: "flex-grow-0 pa-3",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "single-line": "",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "append-icon": _vm.mdiMagnify
    },
    model: {
      value: _vm.filter,
      callback: function ($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _vm.fonts ? _c('v-checkbox', {
    staticClass: "mt-3 ml-n1",
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Show all fonts"
    },
    model: {
      value: _vm.showAll,
      callback: function ($$v) {
        _vm.showAll = $$v;
      },
      expression: "showAll"
    }
  }) : _vm._e()], 1), _c('v-divider', {
    staticClass: "flex-grow-0"
  }), _c('div', {
    staticClass: "flex-grow-1"
  }, [_vm.openDelay ? _c('v-virtual-scroll', {
    staticClass: "fill-height v-list--dense",
    attrs: {
      "items": _vm.filtered,
      "item-height": 40
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item', {
          attrs: {
            "input-value": item == _vm.value
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('input', item);
            }
          }
        }, [_c('v-list-item-title', {
          style: {
            'font-family': _vm.getFontFamily(item)
          },
          domProps: {
            "innerHTML": _vm._s(item)
          }
        })], 1)];
      }
    }], null, false, 73141098)
  }) : _vm._e()], 1)], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }